<div class="modal-header">
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
  <h3 class="modal-title">
    Create A New Morphbox Value for Property {{ row.text }}
  </h3>
</div>
<div>
  <div class="modal-body clearfix">
    <div class="col-lg-12">
      <div class="form-group mb-3">
        <label class="form-label" for="value_name">Value Name:</label>
        <input
          type="text"
          class="form-control"
          id="value_name"
          name="value-name"
          [(ngModel)]="element.text"
          maxlength="{{ inputLengths.MORPHBOX_ELEMENT }}" />
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" class="btn btn-primary">Save Value</button>
  <button (click)="dismiss()" class="btn btn-danger">Cancel</button>
</div>
